export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'edtSNPP';
export const NAME = 'ServisniPaketyPp';
